import React from 'react';

import { MemoizedNavLevelPrivateRoutes } from 'Deer/components/RoutingComps/MemoizedNavLevelPrivateRoutes';
import { GoalAnalyticsProvider } from 'screens/analytics/goals/GoalAnalyticsContext';

const CompanyGoals = () => (
  //   to add validation here if user has access to goals, mydata etc or not

  // why are we still using context to store half of the state? Rest is in redux. Please make it make sense to me >_<
  <GoalAnalyticsProvider>
    <MemoizedNavLevelPrivateRoutes />
  </GoalAnalyticsProvider>
);
export default CompanyGoals;
